const weatherChoicesRo = [
  {
    label: "Vreme stabilă, blândă cu peisaje verzi și tonuri pământii maro.",

    value:
      'Steady, mild weather with green landscapes and earthy brown tones.{"Green":"3","Brown":"2"}',
  },
  {
    label: "Zile înnorate cu gri introspectiv și nori negri misterioși.",
    value:
      'Cloudy days with introspective gray and mysterious black clouds.{"Gray":"3","Black":"2"}',
  },

  {
    label: "Zile liniștite, clare cu cer albastru și seri magice violet.",
    value:
      'Calm, clear days with blue skies and magical violet evenings.{"Blue":"3","Violet":"2"}',
  },

  {
    label: "Zile fierbinți, însorite cu explozii de galben și furtuni energice.",
    value:
      'Hot, sunny days with bursts of yellow and energetic storms.{"Red":"3","Yellow":"2"}',
  },
];

export default weatherChoicesRo;
